import { ICON_DEFAULT_COLOR, ICON_DEFAULT_SIZE } from '@constants/icons';
import { IconProps } from '@models/icons';

function FavoriteFill({ size = ICON_DEFAULT_SIZE, color = ICON_DEFAULT_COLOR, ...rest }: IconProps) {
    return (
        <svg width={size} height={size} viewBox="0 0 29 28" fill="none" xmlns="http://www.w3.org/2000/svg"
            {...rest} >
            <path fillRule="evenodd" clipRule="evenodd"
                d="M14.5 21.25C12.5017 20.815 6.34375 17.4075 6.34375 11.2812C6.34375 10.3302 6.64298 9.4033 7.19906 8.63178C7.75514 7.86027 8.53987 7.28327 9.44209 6.98253C10.3443 6.68179 11.3183 6.67254 12.2261 6.95611C13.1338 7.23968 13.9294 7.80168 14.5 8.5625C15.0706 7.80168 15.8662 7.23968 16.7739 6.95611C17.6817 6.67254 18.6557 6.68179 19.5579 6.98253C20.4601 7.28327 21.2449 7.86027 21.8009 8.63178C22.357 9.4033 22.6562 10.3302 22.6562 11.2812C22.6562 17.4075 16.4983 20.815 14.5 21.25Z"
                fill={color}
                stroke={color}
                strokeWidth="1.93333"/>
        </svg>
    );
}

export default FavoriteFill;
